<div style="width:100%; height: 100%; display: flex; flex-direction: column;">
  <div data-testid="data-grid-widget" class="dx-widget noselect" style="display: flex; flex-direction: column; height: 100%;">
    <dx-toolbar data-testid="data-grid-toolbar">
      <dxi-toolbar-item *ngIf="!filteredExternally" location="before" locateInMenu="never" style="display: flex;">
        <ng-container *ngFor="let filter of gridFilterOptions">
          <div class="filter-control">
            <div data-testid="data-grid-filter-title" class="filter-title">{{filter.name}}:</div>
            <!-- Radio group: desktop (>= 1024px) -->
            <dx-radio-group data-testid="data-grid-radio-group" class="filter-radio-group" [dataSource]="filter.items" layout="horizontal" displayExpr="text" (onValueChanged)="onFilter($event)" [value]="radioGroupValue[filter.name]">
            </dx-radio-group>
            <!-- Select box: tablet/mobile (< 1024px). Binds same data and emits same event. -->
            <dx-select-box data-testid="data-grid-filter-select" class="filter-select-box" [dataSource]="filter.items" displayExpr="text" [value]="radioGroupValue[filter.name]" [searchEnabled]="false" (onValueChanged)="onFilter($event)" [label]="filter.name" labelMode="floating">
            </dx-select-box>
          </div>
        </ng-container>
      </dxi-toolbar-item>
      <dxi-toolbar-item *ngIf="!filteredExternally && checkbox1Text && checkbox2Text" location="before" locateInMenu="auto">
        <div *dxTemplate style="padding-left: 20px;">
          <dx-check-box data-testid="data-grid-check-box-show-completed" (onValueChanged)="onCheckbox1Changed($event)" [text]="checkbox1Text" [value]="checkbox1Value" [visible]="checkbox1Visible">
          </dx-check-box>
        </div>
      </dxi-toolbar-item>
      <dxi-toolbar-item *ngIf="!filteredExternally && checkbox1Text && checkbox2Text" location="before" locateInMenu="auto">
        <div *dxTemplate style="padding-left: 20px;">
          <dx-check-box data-testid="data-grid-check-box-show-rejected" (onValueChanged)="onCheckbox2Changed($event)" [text]="checkbox2Text" [value]="checkbox2Value" [visible]="checkbox2Visible">
          </dx-check-box>
        </div>
      </dxi-toolbar-item>
      <dxi-toolbar-item *ngIf="!filteredExternally && selectBoxVisible" location="before" locateInMenu="auto">
        <div *dxTemplate class="toolbar-select-box-container">
          <div *ngIf="selectBoxLabel" data-testid="data-grid-select-box-label" class="toolbar-select-box-label">{{ selectBoxLabel }}</div>
          <dx-select-box
            data-testid="data-grid-select-box"
            class="toolbar-select-box"
            [items]="selectBoxItems"
            [value]="selectBoxValue"
            [searchEnabled]="false"
            (onValueChanged)="onSelectBoxChanged($event)">
          </dx-select-box>
        </div>
      </dxi-toolbar-item>
      <dxi-toolbar-item *ngIf="filteredExternally" location="before" locateInMenu="never">
        <div *dxTemplate style="padding-left: 20px;">
          <div data-testid="data-grid-filtered-externally-message" class="filtered-externally-message">
            {{ filteredExternallyMessage }}
            <dx-button data-testid="data-grid-button" icon="close" (onClick)="onDismissFilteredExternallyMessage()" hint="Dismiss"></dx-button>
          </div>
        </div>
      </dxi-toolbar-item>
      <dxi-toolbar-item location="after" locateInMenu="never" *ngIf="showAddNew">
        <div *dxTemplate>
          <dx-drop-down-button data-testid="data-grid-drop-down-button" icon="add" [items]="addNewOptions" keyExpr="id" displayExpr="templateType" (onItemClick)="onAddNew($event)" [dropDownOptions]="addNewDropDownOptions" hint="add new">
          </dx-drop-down-button>
        </div>
      </dxi-toolbar-item>
    </dx-toolbar>
    <div data-testid="data-grid-fixed-header-grid" class="fixed-header-grid" style="flex: 1; min-height: 0; max-height: calc(100vh - 200px); overflow: hidden; margin-bottom: 5px;">
      <dx-data-grid data-testid="dataGrid" id="dataGrid" #dxDataGrid keyExpr="id" [dataSource]="rowData" [hoverStateEnabled]="true" [rowAlternationEnabled]="true" [showRowLines]="true" [showColumnLines]="true" [showBorders]="true" [allowColumnReordering]="true" [allowColumnResizing]="true" columnResizingMode="widget" [columnAutoWidth]="true" (onRowDblClick)="onRowDblClick($event)" (onEditorPreparing)="onEditorPreparing($event)" (onEditorPrepared)="onEditorPrepared($event)" (onRowPrepared)="rowPreparedHandler($event)" (onSaving)="onSaving($event)" (onRowUpdating)="onRowUpdating($event)" (onRowUpdated)="onRowUpdated($event)" (onSelectionChanged)="onSelectionChanged($event)" [focusedRowEnabled]="enableFocusedRow" [focusedRowIndex]="focusedRowIndex" (onEditingStart)="editingStart($event)" (onContentReady)="onContentReady($event)" (onExporting)="onExporting($event)" (onCellPrepared)="onCellPrepared($event)" (onContextMenuPreparing)="onContextMenuPreparing($event)" (onRowClick)="onRowClick($event)" class="small-text-grid" (onOptionChanged)="onOptionChanged($event)" [repaintChangesOnly]="repaintChangesOnly" [highlightChanges]="hightlightChanges" [remoteOperations]="{ sorting: true, filtering: true, paging: true, grouping: true }" [cacheEnabled]="cacheEnabled" (onRowExpanding)="onRowExpanding($event)" (onRowCollapsing)="onRowCollapsing($event)" template="master" [height]="gridHeight" style="height: 100%; width: 100%;" showCheckBoxesMode="always">
        <dxo-data-grid-load-panel [enabled]="false"></dxo-data-grid-load-panel>
        <dxo-data-grid-scrolling mode="standard" rowRenderingMode="standard" columnRenderingMode="standard" showScrollbar="always" direction="both" [useNative]="true">
        </dxo-data-grid-scrolling>
        <dxo-data-grid-column-fixing [enabled]="true"></dxo-data-grid-column-fixing>
        <dxo-data-grid-toolbar [items]="toolbarItems"></dxo-data-grid-toolbar>
        <ng-container *ngFor="let summary of summaryConfig"></ng-container>
        <dxo-data-grid-column-chooser [enabled]="true" mode="select"></dxo-data-grid-column-chooser>
        <dxo-data-grid-editing *ngIf="allowEditing" [allowUpdating]="allowUpdating" [allowAdding]="false" [allowDeleting]="allowDeleting" mode="batch"></dxo-data-grid-editing>
        <!-- selectAllMode="page": the remote CustomStore forces take/skip on every load() (#183), which breaks the default "allPages" select-all for this server-paged grid -->
        <dxo-data-grid-selection mode="multiple" [allowSelectAll]="true" selectAllMode="page"></dxo-data-grid-selection>
        <dxo-data-grid-filter-row [visible]="showFilterRow" applyFilter="auto"></dxo-data-grid-filter-row>
        <dxo-data-grid-header-filter [visible]="showHeaderFilter"></dxo-data-grid-header-filter>
        <dxo-data-grid-export [enabled]="true" [allowExportSelectedData]="allowExportSelectedRows"></dxo-data-grid-export>
        <dxo-data-grid-search-panel [visible]="showSearchPanel" [placeholder]="searchPlaceholder" [width]="searchPanelWidth"></dxo-data-grid-search-panel>
        <ng-container *ngIf="columnData && columnData.length > 0">
          <dxi-data-grid-column *ngFor="let column of columnData" [dataField]="column.field" [caption]="column.title" [dataType]="$any(column.dataType)" [allowEditing]="column.allowEditing" [calculateCellValue]="column.valueCalculator" [setCellValue]="$any(column.setCellValue)" [showEditorAlways]="column.showEditorAlways" [allowSearch]="column.allowSearch" [allowFiltering]="column.allowFiltering" [allowSorting]="column.allowSorting !== false" [allowGrouping]="column.allowGrouping !== false" [type]="$any(column.columnType)" [showEditorAlways]="column.showEditorAlways" [cellTemplate]="column.cellTemplate" [calculateFilterExpression]="$any(column.calculateFilterExpression)" [width]="column.width" [visible]="column.visible !== false" [fixed]="column.fixed" [fixedPosition]="column.fixedPosition" [showInColumnChooser]="column.showInColumnChooser !== false">
            <ng-container *ngIf="column.hasCustomFilter">
              <dxo-data-grid-column-header-filter [dataSource]="column.filterDataSource"></dxo-data-grid-column-header-filter>
            </ng-container>
            <ng-container *ngIf="column.columnType === 'simpleLookup'">
              <dxo-data-grid-lookup [dataSource]="column.lookupConfig?.dataSource">
              </dxo-data-grid-lookup>
            </ng-container>
            <ng-container *ngIf="column.dataFormat && column.dataType === 'currency'">
              <dxo-data-grid-format type="fixedPoint" [precision]="column.precision">
              </dxo-data-grid-format>
            </ng-container>
          </dxi-data-grid-column>
          <div *dxTemplate="let cellInfo of 'buttonsTemplate'">
            <ng-container *ngFor="let button of (cellInfo.data | gridButtons:datagridButtons:isButtonDisabled:getButtonHint:getButtonIcon:getButtonClass:isButtonVisible); trackBy: trackButtonById">
              <div data-testid="data-grid-button-with-badge" class="button-with-badge">
                <dx-button [attr.data-testid]="button.id === '3' ? 'data-grid-task-log-button' : 'data-grid-button-4'"
                  [class]="button.cssClass"
                  [hint]="button.hint"
                  [icon]="button.icon"
                  [disabled]="button.disabled"
                  (onClick)="handleButtonClick($event, button, cellInfo.data)">
                </dx-button>
                <span
                  *ngIf="button.id === '1' && cellInfo.data?.unreadCommentCount > 0"
                  class="badge-overlay"
                  [class.large-count]="cellInfo.data.unreadCommentCount >= 10">
                  {{ cellInfo.data.unreadCommentCount }}
                </span>
                <span
                  *ngIf="button.id === '2' && cellInfo.data?.unreadUrlCount > 0"
                  class="badge-overlay badge-overlay-document"
                  [class.large-count]="cellInfo.data.unreadUrlCount >= 10">
                  {{ cellInfo.data.unreadUrlCount }}
                </span>
                <span
                  *ngIf="button.id === '3' && cellInfo.data?.unreadTaskLogCount > 0"
                  data-testid="data-grid-task-log-unread-badge"
                  class="badge-overlay"
                  [class.large-count]="cellInfo.data.unreadTaskLogCount >= 10">
                  {{ cellInfo.data.unreadTaskLogCount }}
                </span>
              </div>
            </ng-container>
          </div>
          <div *dxTemplate="let cellInfo of 'parentTaskDataTemplate'" class="task-detail-cell">
            <ng-container *ngIf="!isDetailColumnHidden(cellInfo.data)">
              <span *ngIf="cellInfo.data?.description && !cellInfo.data?.parentId && !isRedundantDescription(cellInfo.data)" class="task-detail-description" [title]="cellInfo.data.description">{{ cellInfo.data.description }}</span>
              <!-- Value highlighting is parent-row only for now; subtasks fall back to unhighlighted text. -->
              <span class="task-detail-value" [innerHTML]="cellInfo.data?.taskData | formattaskdata:existingColumnNames:deals:(cellInfo.data?.parentId ? null : currentSearchText)"></span>
            </ng-container>
          </div>
          <div *dxTemplate="let cellInfo of 'amountTemplate'">
            <span [ngClass]="getAmountCellClass && getAmountCellClass(cellInfo.data) || ''" [attr.title]="getAmountTooltip ? (getAmountTooltip(cellInfo.data) || null) : null">{{ currencyFormatter && currencyFormatter(cellInfo.data) || cellInfo.data?.amount || '' }}</span>
          </div>
          <div *dxTemplate="let cellInfo of 'statusTemplate'">
            <span class="status-pill" [ngClass]="cellInfo.data?.status | statusClass">
              {{ cellInfo.data?.status }}
            </span>
          </div>
          <div *dxTemplate="let cellInfo of 'dueDateTemplate'">
            <span class="due-date-pill" [ngClass]="getDueDateClass(cellInfo.data?.dueDate, cellInfo.data)">
              {{ cellInfo.data?.dueDate | date:dateDisplayFormat }}
            </span>
          </div>
          <div *dxTemplate="let cellInfo of 'booleanYesNoTemplate'">
            <span class="boolean-display">
              {{ cellInfo | booleanDisplay }}
            </span>
          </div>
          <div *dxTemplate="let cellInfo of 'rushJobTemplate'">
            <span class="boolean-display" [ngClass]="{ 'rush-job-badge': cellInfo | isBooleanYes }" *ngIf="cellInfo | isBooleanYes">
              {{ cellInfo | booleanDisplay }}
            </span>
            <span class="boolean-display" *ngIf="!(cellInfo | isBooleanYes)">
              {{ cellInfo | booleanDisplay }}
            </span>
          </div>
          <div *dxTemplate="let cellInfo of 'isUrgentTemplate'">
            <span class="boolean-display" [ngClass]="{ 'urgent-badge': cellInfo | isBooleanYes }" *ngIf="cellInfo | isBooleanYes">
              {{ cellInfo | booleanDisplay }}
            </span>
            <span class="boolean-display" *ngIf="!(cellInfo | isBooleanYes)">
              {{ cellInfo | booleanDisplay }}
            </span>
          </div>
          <div *dxTemplate="let cellInfo of 'truncatedTextTemplate'">
            <span class="truncated-cell-text" [title]="cellInfo.text">{{ cellInfo.text }}</span>
          </div>
        </ng-container>
        <dxo-data-grid-pager [showPageSizeSelector]="true" [allowedPageSizes]="[20, 50, 100, 200, 300, 500]" [showNavigationButtons]="true" [showInfo]="true" infoText="Page {0} of {1} ({2} items)" [visible]="true">
        </dxo-data-grid-pager>
        <dxo-data-grid-paging [pageSize]="20"></dxo-data-grid-paging>
        <dxo-data-grid-state-storing [enabled]="true" type="custom" [storageKey]="storageKey" [customLoad]="loadGridState" [customSave]="saveGridState">
        </dxo-data-grid-state-storing>
        <dxo-data-grid-group-panel [visible]="effectiveGroupPanelVisible"></dxo-data-grid-group-panel>
        <dxo-data-grid-grouping #expand [autoExpandAll]="autoExpandGroups"></dxo-data-grid-grouping>
        <dx-context-menu data-testid="data-grid-context-menu" [width]="200" height:auto (onHiding)="onContextMenuHiding($event)" target="#dataGrid">
        </dx-context-menu>
        <dxo-data-grid-master-detail [enabled]="hasMasterDetail" template="masterDetails" [autoExpandAll]="false">
        </dxo-data-grid-master-detail>
        <div *dxTemplate="let masterDetailItem of 'masterDetails'">
          <dx-data-grid data-testid="data-grid-data-grid" keyExpr="id" *ngIf="getChildDetails(masterDetailItem.data)?.length" [dataSource]="getChildDetails(masterDetailItem.data)" (onCellPrepared)="onDetailCellPrepared($event)" (onRowPrepared)="onDetailRowPrepared($event)" (onContextMenuPreparing)="onDetailContextMenuPreparing($event)" (onRowDblClick)="onDetailRowDblClick($event,masterDetailItem.data)" (onRowClick)="onDetailRowClick($event,masterDetailItem.data)" (onSelectionChanged)="onDetailSelectionChanged($event, masterDetailItem.data)" [showColumnHeaders]="true" [showBorders]="true" [allowColumnResizing]="true" columnResizingMode="widget" showCheckBoxesMode="always">
            <dxo-sorting mode="none"></dxo-sorting>
            <dxo-data-grid-selection mode="multiple" [allowSelectAll]="true"></dxo-data-grid-selection>
            <ng-container *ngFor="let column of childColumnData">
              <dxi-data-grid-column [dataField]="column.field" [caption]="column.title" [dataType]="$any(column.dataType)" [allowEditing]="column.allowEditing" [calculateCellValue]="column.valueCalculator" [setCellValue]="$any(column.setCellValue)" [showEditorAlways]="column.showEditorAlways" [type]="$any(column.columnType)" [cellTemplate]="column.cellTemplate" [width]="column.width" [visible]="column.visible !== false" [fixed]="column.fixed" [showInColumnChooser]="column.showInColumnChooser !== false">
                <ng-container *ngIf="column.hasCustomFilter">
                  <dxo-data-grid-column-header-filter [dataSource]="column.filterDataSource"></dxo-data-grid-column-header-filter>
                </ng-container>
                <ng-container *ngIf="column.columnType === 'simpleLookup'">
                  <dxo-data-grid-lookup [dataSource]="column.lookupConfig?.dataSource">
                  </dxo-data-grid-lookup>
                </ng-container>
                <ng-container *ngIf="column.dataFormat && column.dataType === 'currency'">
                  <dxo-data-grid-format type="fixedPoint" [precision]="column.precision">
                  </dxo-data-grid-format>
                </ng-container>
              </dxi-data-grid-column>
            </ng-container>
            <!-- Template for detail grid taskData column -->
            <div *dxTemplate="let cellInfo of 'taskDataTemplate'">
              <span [innerHTML]="cellInfo.data?.taskData | formattaskdata:existingColumnNames:deals:currentSearchText"></span>
            </div>
            <!-- Template for detail grid amount column -->
            <div *dxTemplate="let cellInfo of 'amountTemplate'">
              <span [ngClass]="getAmountCellClass && getAmountCellClass(cellInfo.data) || ''" [attr.title]="getAmountTooltip ? (getAmountTooltip(cellInfo.data) || null) : null">{{ currencyFormatter && currencyFormatter(cellInfo.data) || cellInfo.data?.amount || '' }}</span>
            </div>
            <!-- Template for detail grid status column -->
            <div *dxTemplate="let cellInfo of 'statusTemplate'">
              <span class="status-pill" [ngClass]="cellInfo.data?.status | statusClass">
                {{ cellInfo.data?.status }}
              </span>
            </div>
            <!-- Template for detail grid due date column -->
            <div *dxTemplate="let cellInfo of 'dueDateTemplate'">
              <span class="due-date-pill" [ngClass]="getDueDateClass(cellInfo.data?.dueDate, cellInfo.data)">
                {{ cellInfo.data?.dueDate | date:dateDisplayFormat }}
              </span>
            </div>
            <div *dxTemplate="let cellInfo of 'booleanYesNoTemplate'">
              <span class="boolean-display">
                {{ cellInfo | booleanDisplay }}
              </span>
            </div>
            <div *dxTemplate="let cellInfo of 'rushJobTemplate'">
              <span class="boolean-display" [ngClass]="{ 'rush-job-badge': cellInfo | isBooleanYes }" *ngIf="cellInfo | isBooleanYes">
                {{ cellInfo | booleanDisplay }}
              </span>
              <span class="boolean-display" *ngIf="!(cellInfo | isBooleanYes)">
                {{ cellInfo | booleanDisplay }}
              </span>
            </div>
            <div *dxTemplate="let cellInfo of 'isUrgentTemplate'">
              <span class="boolean-display" [ngClass]="{ 'urgent-badge': cellInfo | isBooleanYes }" *ngIf="cellInfo | isBooleanYes">
                {{ cellInfo | booleanDisplay }}
              </span>
              <span class="boolean-display" *ngIf="!(cellInfo | isBooleanYes)">
                {{ cellInfo | booleanDisplay }}
              </span>
            </div>
            <div *dxTemplate="let cellInfo of 'truncatedTextTemplate'">
              <span class="truncated-cell-text" [title]="cellInfo.text">{{ cellInfo.text }}</span>
            </div>
            <dxo-data-grid-paging [enabled]="false"></dxo-data-grid-paging>
          </dx-data-grid>
        </div>
      </dx-data-grid>
    </div>
  </div>
</div>